import type { ReactNode } from 'react';
import { Typography, type SxProps, type Theme } from '@mui/material';

interface SectionLabelProps {
    children: ReactNode;
    sx?: SxProps<Theme>;
}

export function SectionLabel({ children, sx = [] }: SectionLabelProps) {
    return (
        <Typography
            sx={[
                {
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '0.04em',
                    color: 'text.secondary',
                    textTransform: 'uppercase',
                    mb: 0.75,
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Typography>
    );
}
